import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { HELP_WIDGET_LOCATION_LOCAL_STORAGE_KEY } from "../constants";
import { useHelpWidgetContext } from "../context/HelpWidgetContext";
import { useHelpWidgetRoutes } from "../hooks/useHelpWidgetRoutes";

const FULL_SCREEN_AVAILABLE_PATHS = [
  "/form",
  "/posts/",
  "/news/",
  "/message_confirmation/",
  "/conversations/",
] as const;

interface RecentLocationWrapperProps {
  children: React.ReactNode;
}

const isFullScreenAvailableOnPath = (pathname: string): boolean =>
  FULL_SCREEN_AVAILABLE_PATHS.some(path =>
    path.endsWith("/") ? pathname.startsWith(path) : pathname === path,
  ) || pathname.endsWith("/new_ticket");

export const RecentLocationWrapper = ({
  children,
}: RecentLocationWrapperProps): JSX.Element => {
  const { isConversationsRoute } = useHelpWidgetRoutes();
  const location = useLocation();
  const { collapseWidget, collapseSideBar } = useHelpWidgetContext();

  useEffect(() => {
    localStorage.setItem(
      HELP_WIDGET_LOCATION_LOCAL_STORAGE_KEY,
      location.pathname,
    );
    if (!isFullScreenAvailableOnPath(location.pathname)) {
      collapseWidget();
    }
    if (!isConversationsRoute) {
      collapseSideBar();
    }
  }, [
    location.pathname,
    collapseWidget,
    collapseSideBar,
    isConversationsRoute,
  ]);

  return <>{children}</>;
};
